import getValueReduxUtil from 'modules/redux/utils/get-value'
import {
  DAY_KEY,
  getByIdDaysSelector
} from '@gymaholic/packages'
import { isSameDayDateUtil } from 'packages/src'

export const isTodayByIdDaySelector = id => state => {
  const day = getByIdDaysSelector(id)(state)
  const plannedAtStr = getValueReduxUtil(day, DAY_KEY.PLANNED_AT)
  const plannedAt = new Date(plannedAtStr)
  return isSameDayDateUtil(plannedAt, new Date())
}
